export const transformClientIdToStreamUserId = (clientId: string) => {
  return `${clientId}_client`;
};
